import loadable from '@loadable/component';

export const MissingShopModal = loadable(
  () => import(/* webpackChunkName: "extra" */ './missing-shop-modal')
);
